import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Vuetify from 'vuetify'
import VueResource from 'vue-resource'
import '../src/assets/css/custom.css'
import '../src/assets/css/fonts/fonts.css'
import '../src/assets/css/fonts/material/iconfont/material-icons.css'
import { i18n } from '@/plugins/i18n.js'
//import VueAnalytics from 'vue-analytics'
import VueGtag from "vue-gtag";
import mDatePicker from 'vue-multi-date-picker'

// Vue.use(VueAnalytics, {
//   id: 'UA-120534025-2'
// })



Vue.use(VueGtag, {
  config: { id: "UA-120534025-2" }
}, router);

Vue.use(Vuetify)
Vue.use(VueResource)
Vue.use(mDatePicker)

import auth from '../src/api/auth'

auth.checkAuth()

Vue.router = router
Vue.config.productionTip = false


new Vue({
  
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



